/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import ScrollPage from "../../Components/scrollpageUp";
import "./ElementsGroup.css";
import { FiCheckCircle, FiStar, FiShield } from "react-icons/fi";
function ElementsGroup({ navigateWithTransition }) {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const containerRef = useRef(null);
  const activeLinkRef = useRef(null);
  const beforeFooterRef = useRef(null);

  const [showBeforeFooter, setShowBeforeFooter] = useState(false);

  const handleNavigate = (path) => {
    navigateWithTransition(path);
    setMenuOpen(false);
  };

  useEffect(() => {
    if (activeLinkRef.current) {
      activeLinkRef.current.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  }, [location.pathname]);

  useEffect(() => {
    const currentSection = beforeFooterRef.current;
    if (!currentSection) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShowBeforeFooter(true);
        }
      },
      {
        threshold: 0.18,
      }
    );

    observer.observe(currentSection);

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div className="ElemntsGroupPage">
      <ScrollPage />

      <nav className="PageHead">
        <ul className="PageHeadLink" ref={containerRef}>
          {[
            {
              path: "/elements/histoire",
              label: "Histoire & vision du sur-mesure",
            },
            {
              path: "/elements/createurs",
              label: "Les créateurs & l'équipe",
            },
            {
              path: "#",
              label: "Nos ateliers, Store & bureaux",
            },
            {
              path: "/elements/partenaires",
              label: "Partenaires, fournisseurs & marques",
            },
          ].map((item) => {
            const active = location.pathname === item.path;

            return (
              <li key={item.path}>
                <a
                  ref={active ? activeLinkRef : null}
                  className={active ? "active" : ""}
                  onClick={() => handleNavigate(item.path)}
                >
                  {item.label}
                </a>
              </li>
            );
          })}
        </ul>
      </nav>

      <Outlet />

      <section
        ref={beforeFooterRef}
        className={`before_footer ${showBeforeFooter ? "show" : ""}`}
      >
        <div className="before_footer_inner">

          <h1 className="before_footer_title">
            Nos valeurs fondamentales sont au cœur de tout ce que nous faisons
          </h1>

          <div className="before_footer_values">
             <span>
    <FiShield className="value_icon" />
    Honnêteté
  </span>

  <span>
    <FiStar className="value_icon" />
    Qualité
  </span>

  <span>
    <FiCheckCircle className="value_icon" />
    Engagement
  </span>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ElementsGroup;